<!-- Intro Header -->
<header class="sdg-status">
  <div class="intro-body">
    <div class="container">
      <div class="col-md-12">
        <div class="row" appDynamicDirection>
          <div class="col-sm-6 title">
            <h4 class="page-heading" i18n>Water-Related Sustainable Development Goals</h4>
            <h2 class="intro-text" i18n>Integrity - Questionnaire</h2>
          </div>
          <div class="col-sm-6">
            <!-- <a (click)="transparencyBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center "
               style="margin-bottom: 15px;">
              <span i18n>Resources</span>
            </a> -->
            <a (click)="quesBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center "
               style="margin-bottom: 15px; background: #1f487c;">
              <span i18n>Questionnaire</span>
            </a>
            <!-- <a (click)="dataBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center"
               style="margin-bottom: 15px;">
              <span i18n>Data</span>
            </a> -->
            <a (click)="reportBtnClick()" class="col-xs-12 col-sm-6 col-md-8 btn btn-circle-sm text-center"
               style="margin-bottom: 15px;">
              <span i18n>Reporting</span>
            </a>

          </div>
          <div class="content-section" appDynamicDirection>
            <p i18n>The answers to this questionnaire will allow the SDG-PSS to present an overarching perspective of the critical priorities, needs and gaps concerning water-related policies. The approach and process used to answer this questionnaire may vary between countries. However, the key to answer this questionnaire is to conduct a high-level discussion and reach an agreement with different water experts involved in the collection of the data for this component.<br><br>

              Since SDG 6 targets and indicators cover a wide range of water-related dimensions, water experts from different agencies and institutions may answer these questions differently based on a specific SDG 6 target or indicator.<br><br>

              This questionnaire is organised systematically. At the bottom of the page, a button allows the user to save the answers already entered in the questionnaire.<br><br>


For more information and description of this component, please go to the
</p>

<p i18n><a href="{{src_pdf}}" download><strong>User Guide</strong></a>​​.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>


<form name="form" (ngSubmit)="submitForm(f.form.valid)" #f="ngForm" novalidate
      *ngIf="sdgcomponent$ | async as sdgcomponent">
  <section class="content-section" *ngFor="let cat of ordered_component.category; let i = index">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="table-h1 text-center">
            <a href="{{admin_url}}admin/pss_app/category/{{cat.id}}/change/" *ngIf="testmode" class="edit-link"
               target="_blank">edit</a>
            {lang, plural, =2 {{{cat.name_fr}}} =3 {{{cat.name_es}}} =4 {{{cat.name_pt}}} =5 {{{cat.name_ko}}} =6 {{{cat.name_ar}}} other {{{cat.name}}} }
            <!-- Access, Target 6.1: By 2030, achieve universal and equitable access to safe and affordable drinking water for all -->
            <button *ngIf="lang==1 && cat.description" type="button" class="guide-btn" (click)="openGuide(cat.description)">?</button>
            <button *ngIf="lang==2 && cat.description_fr" type="button" class="guide-btn" (click)="openGuide(cat.description_fr)">?</button>
            <button *ngIf="lang==3 && cat.description_es" type="button" class="guide-btn" (click)="openGuide(cat.description_es)">?</button>
            <button *ngIf="lang==4 && cat.description_pt" type="button" class="guide-btn" (click)="openGuide(cat.description_pt)">?</button>
            <button *ngIf="lang==5 && cat.description_ko" type="button" class="guide-btn" (click)="openGuide(cat.description_ko)">?</button>
            <button *ngIf="lang==6 && cat.description_ar" type="button" class="guide-btn" (click)="openGuide(cat.description_ar)">?</button>
          </div>
        </div>
      </div>
      <div *ngFor="let subcat of cat.sub_category; let j = index">
        <div class="row">
          <div class="col-md-12">
            <div class="table-h2 text-center">
              <a href="{{admin_url}}admin/pss_app/subcategory/{{subcat.id}}/change/" *ngIf="testmode" class="edit-link"
                 target="_blank">edit</a>
              {lang, plural, =2 {{{subcat.name_fr}}} =3 {{{subcat.name_es}}} =4 {{{subcat.name_pt}}} =5 {{{subcat.name_ko}}} =6 {{{subcat.name_ar}}} other {{{subcat.name}}} }
              <!-- Indicator 6.1.1 Proportion of population using safely managed drinking water services. -->
            <button *ngIf="lang==1 && subcat.description" type="button" class="guide-btn" (click)="openGuide(subcat.description)">?</button>
            <button *ngIf="lang==2 && subcat.description_fr" type="button" class="guide-btn" (click)="openGuide(subcat.description_fr)">?</button>
            <button *ngIf="lang==3 && subcat.description_es" type="button" class="guide-btn" (click)="openGuide(subcat.description_es)">?</button>
            <button *ngIf="lang==4 && subcat.description_pt" type="button" class="guide-btn" (click)="openGuide(subcat.description_pt)">?</button>
            <button *ngIf="lang==5 && subcat.description_ko" type="button" class="guide-btn" (click)="openGuide(subcat.description_ko)">?</button>
            <button *ngIf="lang==6 && subcat.description_ar" type="button" class="guide-btn" (click)="openGuide(subcat.description_ar)">?</button>
            </div>
          </div>
        </div>
        <div *ngFor="let quecat of subcat.question_category; let k = index">
          <!-- If not a  pool question -->
          <div *ngIf="quecat.question_type!='Empty'">
            <div *ngIf="quecat.visible">
            <div class="row" *ngIf="quecat.itself_question==false">
              <div class="col-md-6 pr">
                <div class="questions-section-alt" [class.light_blue]="k%2==1" [class.dark_blue]="k%2==0">
              <a href="{{admin_url}}admin/pss_app/questioncategory/{{quecat.id}}/change/" *ngIf="testmode" class="edit-link" target="_blank">edit</a>
                  {lang, plural, =2 {{{quecat.name_fr}}} =3 {{{quecat.name_es}}} =4 {{{quecat.name_pt}}} =5 {{{quecat.name_ko}}} =6 {{{quecat.name_ar}}} other {{{quecat.name}}} }
                </div>
              </div>
              <div class="col-md-6 pl">
                <div class="answers-section">
                  <div class="column">{{option_translation(quecat.option1, lang)}}<button *ngIf="quecat.guide?.option1_description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.option1_description)">?</button></div>
                  <div class="column">{{option_translation(quecat.option2, lang)}}<button *ngIf="quecat.guide?.option2_description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.option2_description)">?</button></div>
                  <div class="column">{{option_translation(quecat.option3, lang)}}<button *ngIf="quecat.guide?.option3_description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.option3_description)">?</button></div>
                  <div class="column">{{option_translation(quecat.option4, lang)}}<button *ngIf="quecat.guide?.option4_description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.option4_description)">?</button></div>
                </div>
              </div>
            </div>

            <div class="row" appDynamicDirection *ngIf="quecat.itself_question">
              <div class="col-md-6 pr">
                <div class="questions-section-alt single_que" [class.light_blue]="k%2==1" [class.dark_blue]="k%2==0">
              <a href="{{admin_url}}admin/pss_app/questioncategory/{{quecat.id}}/change/" *ngIf="testmode" class="edit-link" target="_blank">edit</a>
                  {lang, plural, =2 {{{quecat.name_fr}}} =3 {{{quecat.name_es}}} =4 {{{quecat.name_pt}}} =5 {{{quecat.name_ko}}} =6 {{{quecat.name_ar}}} other {{{quecat.name}}} }
                  <button *ngIf="lang==1 && quecat.guide?.description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.description)">?</button>
                  <button *ngIf="lang==2 && quecat.guide?.description_fr" type="button" class="guide-btn" (click)="openGuide(quecat.guide.description_fr)">?</button>
                  <button *ngIf="lang==3 && quecat.guide?.description_es" type="button" class="guide-btn" (click)="openGuide(quecat.guide.description_es)">?</button>
                  <button *ngIf="lang==4 && quecat.guide?.description_pt" type="button" class="guide-btn" (click)="openGuide(quecat.guide.description_pt)">?</button>
                  <button *ngIf="lang==5 && quecat.guide?.description_ko" type="button" class="guide-btn" (click)="openGuide(quecat.guide.description_ko)">?</button>
                  <button *ngIf="lang==6 && quecat.guide?.description_ar" type="button" class="guide-btn" (click)="openGuide(quecat.guide.description_ar)">?</button>
                </div>
              </div>
              <div  *ngIf="quecat.question_type=='RadioButtons3'" class="col-md-6 pl">
                <div class="answers-section">
                  <div class="column">{{option_translation(quecat.option1, lang)}}<button *ngIf="quecat.guide?.option1_description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.option1_description)">?</button></div>
                  <div class="column">{{option_translation(quecat.option2, lang)}}<button *ngIf="quecat.guide?.option2_description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.option2_description)">?</button></div>
                  <div class="column">{{option_translation(quecat.option3, lang)}}<button *ngIf="quecat.guide?.option3_description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.option3_description)">?</button></div>
                </div>
                <div>
                  <mat-radio-group [(ngModel)]="values[quecat.question[0].id]" (change)="radioChange($event)" [selected]="firstName" [ngModelOptions]="{standalone: true}" class="answers answers-section">
                    <mat-radio-button #firstName [checked]="true" [value]="option1[quecat.question[0].id]" class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                    <mat-radio-button [value]="option2[quecat.question[0].id]" class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                    <mat-radio-button [value]="option3[quecat.question[0].id]" class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
              <div  *ngIf="quecat.question_type=='RadioButtons'" class="col-md-6 pl">
                <div class="answers-section">
                  <div class="column">{{option_translation(quecat.option1, lang)}}<button *ngIf="quecat.guide?.option1_description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.option1_description)">?</button></div>
                  <div class="column">{{option_translation(quecat.option2, lang)}}<button *ngIf="quecat.guide?.option2_description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.option2_description)">?</button></div>
                  <div class="column">{{option_translation(quecat.option3, lang)}}<button *ngIf="quecat.guide?.option3_description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.option3_description)">?</button></div>
                  <div class="column">{{option_translation(quecat.option4, lang)}}<button *ngIf="quecat.guide?.option4_description" type="button" class="guide-btn" (click)="openGuide(quecat.guide.option4_description)">?</button></div>
                </div>
                <div>
                  <mat-radio-group [(ngModel)]="values[quecat.question[0].id]" (change)="radioChange($event)" [selected]="firstName" [ngModelOptions]="{standalone: true}" class="answers answers-section">
                    <mat-radio-button #firstName [checked]="true" [value]="option1[quecat.question[0].id]" class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                    <mat-radio-button [value]="option2[quecat.question[0].id]" class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                    <mat-radio-button [value]="option3[quecat.question[0].id]" class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                    <mat-radio-button [value]="option4[quecat.question[0].id]" class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>
            </div>

            <div *ngFor="let ques of quecat.question; let l = index">
              <div class="row" *ngIf="quecat.itself_question==false">
                <ng-container *ngIf="ques.visible">
                <div class="col-md-6 pr">
                  <div class="questions-alt" [class.light_blue]="k%2==1" [class.dark_blue]="k%2==0">
                      <a href="{{admin_url}}admin/pss_app/question/{{ques.id}}/change/" *ngIf="testmode" class="edit-link" target="_blank">edit</a>
                      {lang, plural, =2 {{{ques.question_text_fr}}} =3 {{{ques.question_text_es}}} =4 {{{ques.question_text_pt}}} =5 {{{ques.question_text_ko}}} =6 {{{ques.question_text_ar}}} other {{{ques.question_text}}} }
                      <button *ngIf="lang==1 && ques.description" type="button" class="guide-btn" (click)="openGuide(ques.description)">?</button>
                      <button *ngIf="lang==2 && ques.description_fr" type="button" class="guide-btn" (click)="openGuide(ques.description_fr)">?</button>
                      <button *ngIf="lang==3 && ques.description_es" type="button" class="guide-btn" (click)="openGuide(ques.description_es)">?</button>
                      <button *ngIf="lang==4 && ques.description_pt" type="button" class="guide-btn" (click)="openGuide(ques.description_pt)">?</button>
                      <button *ngIf="lang==5 && ques.description_ko" type="button" class="guide-btn" (click)="openGuide(ques.description_ko)">?</button>
                      <button *ngIf="lang==6 && ques.description_ar" type="button" class="guide-btn" (click)="openGuide(ques.description_ar)">?</button>
                  </div>
                </div>
                <div *ngIf="ques.question_type_name!='Details' && quecat.itself_question==false" class="col-md-6 pl">
                  <mat-radio-group [(ngModel)]="values[ques.id]" (change)="radioChange($event)" [selected]="firstName" [ngModelOptions]="{standalone: true}" class="answers answers-section">
                    <mat-radio-button #firstName [checked]="true" [value]="option1[ques.id]" class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                    <mat-radio-button [value]="option2[ques.id]" class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                    <mat-radio-button [value]="option3[ques.id]" class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                    <mat-radio-button [value]="option4[ques.id]" class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                  </mat-radio-group>
                </div>
                <div *ngIf="ques.question_type_name=='Details'" class="col-md-6 pl">
                  <div class="input-answers">
                    <input [(ngModel)]="values[ques.id].value" [ngModelOptions]="{standalone: true}" type="text" class="form-control" maxlength="255"/>
                  </div>
                </div>
                </ng-container>
              </div>
            </div>
          </div>
          </div>








          <!-- If a pool question -->
          <div *ngIf="quecat.question_type=='Empty'">

            <div class="row" *ngIf="team_pool_questions>0">
              <div class="col-md-6 pr">
                <div class="questions-section-alt" [class.light_blue]="k%2==1" [class.dark_blue]="k%2==0">
                  <a href="{{admin_url}}admin/pss_app/questioncategory/{{quecat.id}}/change/" *ngIf="testmode"
                     class="edit-link" target="_blank">edit</a>
                  {lang, plural, =2 {{{quecat.name_fr}}} =3 {{{quecat.name_es}}} =4 {{{quecat.name_pt}}} =5 {{{quecat.name_ko}}} =6 {{{quecat.name_ar}}} other {{{quecat.name}}} }
                </div>
              </div>
              <div class="col-md-6 pl">
                <div class="answers-section">
                  <div class="column">{{option_translation(quecat.option1, lang)}}</div>
                  <div class="column">{{option_translation(quecat.option2, lang)}}</div>
                  <div class="column">{{option_translation(quecat.option3, lang)}}</div>
                  <div class="column">{{option_translation(quecat.option4, lang)}}</div>
                </div>
              </div>
            </div>

            <div *ngFor="let ques of quecat.question; let l = index">
              <div class="row" *ngIf="ques.team==team">
                <div class="col-md-6 pr">
                  <div class="questions-alt single_que" [class.light_blue]="k%2==1" [class.dark_blue]="k%2==0">
                      <a href="{{admin_url}}admin/pss_app/question/{{ques.id}}/change/" *ngIf="testmode"
                         class="edit-link" target="_blank">edit</a>
                      {lang, plural, =2 {{{ques.question_text_fr}}} =3 {{{ques.question_text_es}}} =4 {{{ques.question_text_pt}}} =5 {{{ques.question_text_ko}}} =6 {{{ques.question_text_ar}}} other
                      {{{ques.question_text}}} }
                      <button *ngIf="lang==1 && ques.description" type="button" class="guide-btn" (click)="openGuide(ques.description)">?</button>
                      <button *ngIf="lang==2 && ques.description_fr" type="button" class="guide-btn" (click)="openGuide(ques.description_fr)">?</button>
                      <button *ngIf="lang==3 && ques.description_es" type="button" class="guide-btn" (click)="openGuide(ques.description_es)">?</button>
                      <button *ngIf="lang==4 && ques.description_pt" type="button" class="guide-btn" (click)="openGuide(ques.description_pt)">?</button>
                      <button *ngIf="lang==5 && ques.description_ko" type="button" class="guide-btn" (click)="openGuide(ques.description_ko)">?</button>
                      <button *ngIf="lang==6 && ques.description_ar" type="button" class="guide-btn" (click)="openGuide(ques.description_ar)">?</button>
                  </div>
                </div>
                <div class="col-md-6 pl">
                  <div class="answers-section">
                    <div class="column">{{option_translation(ques.option1, lang)}}</div>
                    <div class="column">{{option_translation(ques.option2, lang)}}</div>
                    <div class="column">{{option_translation(ques.option3, lang)}}</div>
                    <div class="column">{{option_translation(ques.option4, lang)}}</div>
                  </div>
                </div>
                <div *ngIf="ques.question_options!='1'" class="col-md-6 pl">
                  <mat-radio-group [(ngModel)]="values[ques.id]" (change)="radioChange($event)" [selected]="firstName"
                                   [ngModelOptions]="{standalone: true}" class="answers answers-section">
                    <mat-radio-button *ngIf="ques.option1" #firstName [checked]="true" [value]="option1[ques.id]"
                                      class="radio-input" style="margin: 0 auto;"></mat-radio-button>
                    <mat-radio-button *ngIf="ques.option2" [value]="option2[ques.id]" class="radio-input"
                                      style="margin: 0 auto;"></mat-radio-button>
                    <mat-radio-button *ngIf="ques.option3" [value]="option3[ques.id]" class="radio-input"
                                      style="margin: 0 auto;"></mat-radio-button>
                    <mat-radio-button *ngIf="ques.option4" [value]="option4[ques.id]" class="radio-input"
                                      style="margin: 0 auto;"></mat-radio-button>
                  </mat-radio-group>
                </div>
                <div *ngIf="ques.question_options=='1'" class="col-md-6 pl">
                  <div class="input-answers" style="padding:  0px;">
                    <input [(ngModel)]="values[ques.id].value" [ngModelOptions]="{standalone: true}" type="text"
                           class="form-control" maxlength="255"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="container">
    <div class="form-group col-md-6 col-md-offset-6" style="margin-top: 15px;">
      <div class="pull-right"><span *ngIf="this.last_saved">Last Saved On: {{this.last_saved | date:'medium'}}</span>
        <button (click)="this.is_partial='false'" [disabled]="loading" class="btn btn-default" i18n>Submit Form
          <img *ngIf="loading && is_partial=='false'"
               src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
        </button>
        <button (click)="this.is_partial='true'" [disabled]="loading" class="btn btn-primary save_button" i18n>Save
          <img *ngIf="loading && is_partial=='true'"
               src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="/>
        </button>
      </div>
    </div>
  </div>
</form>

<!-- Guide Panel -->
<div class="guide-panel" [class.guide-panel-open]="guidePanelOpen">
  <div class="guide-panel-header">
    <span i18n>Guide</span>
    <button type="button" class="guide-close-btn" (click)="closeGuide()">&#x2715;</button>
  </div>
  <div class="guide-panel-body">
    <div [innerHTML]="guideText"></div>
    <div *ngIf="guideLinks.length > 0" class="guide-links-section">
      <div class="guide-links-title">Links</div>
      <ul class="guide-links-list">
        <li *ngFor="let link of guideLinks">
          <a [href]="link.url" target="_blank">{{link.label}}</a>
        </li>
      </ul>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/sdg/transparency-quest/transparency-quest.component.html